import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ControlContainer, FormGroup, ReactiveFormsModule } from '@angular/forms';

@Component({
  selector: 'app-scale',
  templateUrl: './scale.component.html',
  styleUrls: ['./scale.component.scss'],
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule]
})
export class ScaleComponent implements OnInit {
  @Input() question: any;
  @Input() form!: FormGroup;

  scaleValues: (number | string)[] = [];

  constructor(private readonly controlContainer: ControlContainer) {}

  ngOnInit(): void {
    this.form = this.controlContainer.control as FormGroup;
    this.scaleValues = this.generateScaleValues();    
  }

  private generateScaleValues(): (number | string)[] {
    const { min, max } = this.question.scale;
    if (typeof min.value === 'number' && typeof max.value === 'number') {
      return Array.from({ length: max.value - min.value + 1 }, (_, i) => min.value + i);
    } else if (typeof min.value === 'string' && typeof max.value === 'string') {
      return this.generateAlphabeticRange(min.value, max.value);
    } else {
      console.error('Invalid scale values provided');
      return [];
    }
  }

  private generateAlphabeticRange(start: string, end: string): string[] {
    const startCharCode = start.toUpperCase().charCodeAt(0);
    const endCharCode = end.toUpperCase().charCodeAt(0);
    
    if (startCharCode > endCharCode) {
      console.error('Invalid alphabetic range: start must be before end');
      return [];
    }

    return Array.from(
      { length: endCharCode - startCharCode + 1 },
      (_, i) => String.fromCharCode(startCharCode + i)
    );
  }

  setScaleValue(value: number | string) {
    this.form.controls[this.question.uniqueId].setValue(value, { onlySelf: false, emitEvent: true });
    this.form.controls[this.question.uniqueId].markAsDirty();
  }
}
